import React from "react";
import App from "./App";
import "./index.scss";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./config/ssoConfig";
import { PublicClientApplication } from '@azure/msal-browser';

import { createRoot } from "react-dom/client";

const container = document.getElementById("root");
const root = createRoot(container);
const msalInstance = new PublicClientApplication(msalConfig);

root.render(
    <MsalProvider instance={msalInstance}>
        <App />
    </MsalProvider>
);
